import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_UR,
    useChartsData
} from '../../../../Common/hooks/useChartsData';

export const PeopleChartsDataContext = createContext();

const PeopleChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_UR.PEOPLE_MAPPING,
            url: 'governanceroom/dashboard/unifiedregistry/mapping/people'
        },
        {
            location: filters.unidade.value,
            city: filters.cidade?.value,
        }
    );

    const chartData = data
        ? {
              indicators: {
                  young: data?.indicators?.young ?? 0,
                  peopleRegistered: data?.indicators?.peopleRegistered ?? 0,
                  adults: data?.indicators?.adults ?? 0,
                  elderlies: data?.indicators?.elderlies ?? 0
              },
              people: data?.people ?? [],
              familiesMap: data?.familiesMap ?? []
          }
        : {
              indicators: {
                  young: 0,
                  peopleRegistered: 0,
                  adults: 0,
                  elderlies: 0
              },
              people: [],
              familiesMap: []
          };

    return (
        <PeopleChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </PeopleChartsDataContext.Provider>
    );
};

export default PeopleChartsDataProvider;
